export const tooltip = {   
    baseStyle:{
        fontSize: "12px"
    }
    
}